module.exports = __webpack_public_path__ + "25f1283e2ed16027807127225bd5272e.woff2";